<template>
  <div class="navbar" :class="{ 'scrolled': isScrolled }">
    <div class="navbar-top" :class="{ 'showNavBack': !isShowNavBack }">
      <div class="page-container">
        <div class="left-section">
          <Logo to="/" />
        </div>
        <div class="navbar-main">
          <div class="page-container main-container">
            <div class="menu-columns">
              <div class="menu-column" :class="{ 'is-active': activeIndex === '/' }" @click="handleSelect('/')"
                @mouseenter="hideCartMenu">
                <span>首页</span>
              </div>
              <div class="menu-column" :class="{ 'is-active': activeIndex === '/cart' }" @mouseenter="showCartMenu">
                <span style="margin-right: 4px;">自行车</span><el-icon>
                  <ArrowDown />
                </el-icon>
              </div>
              <div class="menu-column" :class="{ 'is-active': activeIndex === '/about' }"
                @click="handleSelect('/about')" @mouseenter="hideCartMenu">
                <span>关于我们</span>
              </div>
              <div class="menu-column" :class="{ 'is-active': activeIndex === '/news' }" @click="handleSelect('/news')"
                @mouseenter="hideCartMenu">
                <span>新闻资讯</span>
              </div>
            </div>
          </div>
        </div>

        <div class="right-section">
          <div class="action-buttons">
            <!-- <a href="#" class="language-switcher">EN</a> -->
            <el-input class="search-input" placeholder="搜索" v-model="searchKeyword" @keyup.enter="handleSearch">
              <template #prefix>
                <el-icon>
                  <Search />
                </el-icon>
              </template>
            </el-input>
          </div>
        </div>
      </div>
      <div class="navbar-zxc" :class="navbarClass" @mouseleave="hideCartMenu">
        <div class="navbar-columns" v-loading="isLoading">
          <div class="navbar-column" v-for="cate in categorys">
            <h3>{{cate.name || '-'}}</h3>
            <ul class="navbar-links">
              <li  v-for="child in cate.children"><router-link :to="`/products/${child.id}`">{{ child.name || '-' }}</router-link></li>
            </ul>
          </div>

           <!-- <div class="navbar-column">
            <h3>公主车</h3>
            <ul class="navbar-links">
              <li><router-link to="/product">轮组</router-link></li>
              <li><router-link to="/product">车把</router-link></li>
              <li><router-link to="/product">座管</router-link></li>
              <li><router-link to="/product">坐垫</router-link></li>
            </ul>
          </div>-->
        </div>
      </div>
    </div>



    <!-- 移动端菜单 -->
    <div class="mobile-navbar">
      <div class="mobile-navbar-top">
        <div class="mobile-logo">
          <Logo to="/" :mobile="true" />
        </div>
        <div class="mobile-actions">
          <el-icon class="icon-btn" @click="showSearch = !showSearch">
            <Search />
          </el-icon>
          <el-icon class="icon-btn" @click="toggleMobileMenu">
            <component :is="mobileMenuOpen ? Close : Menu" />
          </el-icon>
        </div>
      </div>

      <div class="mobile-search" v-if="showSearch">
        <el-input placeholder="搜索" v-model="searchKeyword" @keyup.enter="handleSearch">
          <template #prefix>
            <el-icon>
              <Search />
            </el-icon>
          </template>
        </el-input>
      </div>

      <div class="mobile-menu" v-if="mobileMenuOpen">
        <el-collapse accordion>
          <el-collapse-item title="首页" name="home">
            <router-link to="/" @click="toggleMobileMenu">首页</router-link>
          </el-collapse-item>
          <el-collapse-item title="自行车" name="business">
            <router-link  v-for="child in categorys[0].children" @click="toggleMobileMenu" :to="`/products/${child.id}`">{{ child.name || '-' }}</router-link>
            <!-- <router-link to="/product" @click="toggleMobileMenu">童车</router-link> -->
          </el-collapse-item>
          <el-collapse-item title="企业介绍" name="about">
            <router-link to="/about" @click="toggleMobileMenu">公司简介</router-link>
            <router-link to="/about/history" @click="toggleMobileMenu">发展历程</router-link>
          </el-collapse-item>
          <el-collapse-item title="关于我们" name="contact">
            <router-link to="/recruits" @click="toggleMobileMenu">人才招聘</router-link>
            <router-link to="/touch" @click="toggleMobileMenu">联系我们</router-link>
          </el-collapse-item>
          <el-collapse-item title="新闻资讯" name="news">
            <router-link to="/news" @click="toggleMobileMenu">新闻资讯</router-link>
          </el-collapse-item>
        </el-collapse>
      </div>
    </div>
  </div>
</template>

<script>
import { useRoute, useRouter } from 'vue-router';
import { ref, computed, onMounted, onUnmounted, watch } from 'vue';
import { Search, Menu, Close } from '@element-plus/icons-vue';
import Logo from './Logo.vue';
import { getCategoryAll } from '@/api/product';

export default {
  name: 'Navbar',
  components: {
    Logo,
    Search,
    Menu,
    Close
  },
  setup() {
    const route = useRoute();
    const router = useRouter();
    const isScrolled = ref(false);
    const isShowNavBack = ref(false);
    const mobileMenuOpen = ref(false);
    const showSearch = ref(false);
    const searchKeyword = ref('');
    const categorys = ref([]);
    const isLoading = ref(false);

    // 计算当前活动菜单
    const activeIndex = computed(() => {
      return route.path;
    });

    const isCartMenuVisible = ref(false);
    let showCartMenuTime = null;
    let hideCartMenuTime = null;
    const showLoading = ref(false);
    const hideLoading = ref(false);

    const showCartMenu = () => {
      if (showLoading.value) return;
      showLoading.value = true;
      showCartMenuTime = setTimeout(() => {
        isCartMenuVisible.value = true;
        showLoading.value = false;
        clearTimeout(showCartMenuTime)
      }, 100);
    };

    const hideCartMenu = () => {
      if (isCartMenuVisible.value == false) return;
      hideLoading.value = true;
      //正在执行就无视
      hideCartMenuTime = setTimeout(() => {
        if (!showLoading.value) {
          isCartMenuVisible.value = false;
          hideLoading.value = false;
        }

        clearTimeout(hideCartMenuTime)
      }, 100);
    };

    // 隐藏动画
    const navbarClass = computed(() => {
      return {
        'animation': isCartMenuVisible.value,
        'animation2': !isCartMenuVisible.value,
        // 这里可以添加其他动态样式
      };
    });

    // 处理滚动事件
    const handleScroll = () => {
      if (typeof window !== 'undefined') {
        isScrolled.value = window.scrollY > 50;
        isShowNavBack.value = window.scrollY === 0;
      }
    };

    // 切换移动端菜单
    const toggleMobileMenu = () => {
      mobileMenuOpen.value = !mobileMenuOpen.value;
      if (mobileMenuOpen.value) {
        showSearch.value = false;
      }
    };

    // 搜索处理
    const handleSearch = () => {
      if (searchKeyword.value && searchKeyword.value.trim()) {
        router.push({
          path: '/search',
          query: { q: searchKeyword.value }
        });
        searchKeyword.value = '';
        showSearch.value = false;
      }
    };

    // 菜单项点击
    const handleSelect = (index) => {
      if (index) {
        router.push(index);
      }
    };

    // 登录处理
    const handleLoginClick = () => {
      if (typeof window !== 'undefined') {
        window.location.href = "https://vorlad.top";
      }
    };

    // 路由变化时关闭移动菜单
    watch(() => route.path, () => {
      mobileMenuOpen.value = false;
      showSearch.value = false;
    });

    // 获取分类
    const fetchCates = async () => {
      isLoading.value = true;
      try {
        const res = await getCategoryAll();
        if (res && res.data) {
          categorys.value = res.data?.map(item => {
            return {
              id: item.id,
              name: item.name,
              children: item?.children.map(c => { return { id: c.id, name: c.name } })
            }
          })
          //console.log(JSON.stringify(categorys.value));
        }

      } catch (error) {
        console.error('获取失败:', error);
        categorys.value = [];
      } finally {
        isLoading.value = false;
      }
    };

    onMounted(() => {
      fetchCates();
      if (typeof window !== 'undefined') {
        window.addEventListener('scroll', handleScroll);
        handleScroll();
      }
    });

    onUnmounted(() => {
      if (typeof window !== 'undefined') {
        window.removeEventListener('scroll', handleScroll);
      }
    });

    return {
      activeIndex,
      isScrolled,
      isShowNavBack,
      mobileMenuOpen,
      showSearch,
      searchKeyword,
      toggleMobileMenu,
      handleSearch,
      handleSelect,
      handleLoginClick,
      Search,
      Menu,
      Close,
      isCartMenuVisible,
      showCartMenu,
      hideCartMenu,
      navbarClass,
      isLoading,
      categorys
    };
  }
}
</script>

<style lang="scss" scoped>
.is-light {
  background: #333 !important;
  border: 1px solid #333 !important;
}

.navbar {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  z-index: 1000;


  .navbar-top {
    //background-color: #fff;
    padding: 15px 0 5px 0;

    &:hover,
    &.showNavBack {
      background-color: #000 !important;
      box-shadow: 0 4px 10px rgba(255, 255, 255, 0.3);
      /* 白色光影 */
    }



    .page-container {
      max-width: 100%;
      display: flex;
      justify-content: space-between;
      align-items: center;
    }

    .left-section {
      display: flex;
      align-items: center;
    }

    .right-section {
      display: flex;
      align-items: center;

      .action-buttons {
        display: flex;
        align-items: center;
        gap: 15px;

        .language-switcher {
          color: #333;
          font-weight: 500;
          text-decoration: none;

          &:hover {
            color: var(--primary-color);
          }
        }

        .search-input {
          width: 180px;
        }
      }
    }
  }

  .navbar-main {
    // background-color: #163C7D;

    .main-container {
      display: flex;
      justify-content: space-between;
    }

    .menu-columns {
      display: grid;
      grid-template-columns: repeat(4, 1fr);
      gap: 0px;

      .menu-column {
        padding: 0px 15px;
        height: 60px;
        line-height: 60px;
        font-size: 16px;
        font-weight: 500;
        color: #fff;
        text-align: center;
        display: flex;
        flex-direction: row;
        align-items: center;

        &.is-active {
          // background-color: rgba(255, 255, 255, 0.3) !important;
          // border-bottom: 3px solid #fff;
          color: #10DD1E;
        }

        &:hover {
          background-color: rgba(255, 255, 255, 0.2) !important;
          color: #10DD1E;
        }
      }
    }

    .main-menu {
      border-bottom: none;
      display: flex;
      justify-content: space-between;
      width: 100%;
    }


  }

  .mobile-navbar {
    display: none;
    background-color: #fff;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);

    .mobile-navbar-top {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 15px 20px;
    }

    .mobile-actions {
      display: flex;
      align-items: center;
      gap: 20px;

      .icon-btn {
        font-size: 24px;
        cursor: pointer;
        color: #333;
      }
    }

    .mobile-search {
      padding: 0 15px 15px;
    }

    .mobile-menu {
      background-color: #f5f5f5;
    }

    :deep(.el-collapse-item__header) {
      padding: 0 15px;
      height: 50px;
      line-height: 50px;
      font-size: 16px;
      font-weight: 500;
      color: #333;
    }

    :deep(.el-collapse-item__content) {
      padding: 0;

      a {
        display: block;
        padding: 12px 30px;
        color: #666;
        text-decoration: none;
        border-bottom: 1px solid #eee;

        &:hover {
          color: var(--primary-color);
          background-color: #f0f0f0;
        }
      }
    }
  }
}

.navbar-zxc {
  background-color: #000;
  width: calc(100vw - 20px);
  margin: 0 !important;
  display: flex;
  flex-direction: column;
  align-items: center;
  overflow: hidden;
  height: 0px;

  &.animation {
    padding: 40px 0px;
    height: auto;
    animation: slideDown 0.3s ease-out forwards;
  }

  &.animation2 {
    animation: slideUp 0.3s ease-out forwards;
  }



  /* 动画 */
  @keyframes slideDown {
    from {
      height: 0px;
    }

    to {
      height: 300px;
    }
  }

  /* 动画 */
  @keyframes slideUp {
    from {
      padding: 40px 0px;
      height: 300px;
    }

    to {
      padding: 0px 0px;
      height: 0px;
    }
  }
}

.navbar-columns {
  width: 600px;
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 30px;
}

.navbar-column {

  h3 {
    font-size: 18px;
    color: #FFF;
    margin-bottom: 20px;
    font-weight: 600;
    position: relative;
    padding-bottom: 12px;

    &::after {
      content: '';
      position: absolute;
      left: 0;
      bottom: 0;
      width: 40px;
      height: 2px;
      background-color: #10DD1E;
    }
  }

  .navbar-links {
    list-style: none;
    padding: 0;
    margin: 0;

    li {
      margin-bottom: 12px;

      a {
        color: #FFF;
        text-decoration: none;
        font-size: 14px;
        transition: all 0.3s;
        position: relative;
        padding-left: 15px;

        &::before {
          content: '';
          position: absolute;
          left: 0;
          top: 8px;
          width: 5px;
          height: 5px;
          border-radius: 50%;
          background-color: #ccc;
        }

        &:hover {
          color: #10DD1E;
          padding-left: 18px;

          &::before {
            background-color: #10DD1E;
          }
        }
      }
    }
  }


}

// 响应式调整
@media (max-width: 992px) {
  .navbar {

    .navbar-top,
    .navbar-main {
      display: none;
    }

    .mobile-navbar {
      display: block;
    }
  }
}
</style>